import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    // For demo purposes, always simulate socket connection when user exists
    // In a real app, you'd connect to the actual socket server
    if (user) {
      const simulateConnection = () => {
        setTimeout(() => {
          setIsConnected(true);
          console.log('Demo: Socket connected for user:', user.name);
        }, 500);
      };
      
      simulateConnection();
      
      // Cleanup function
      return () => {
        setIsConnected(false);
        console.log('Demo: Socket disconnected');
      };
    } else {
      setIsConnected(false);
    }
  }, [user]);

  const emit = (event, data) => {
    if (isConnected) {
      // Demo mode - just log the event
      console.log(`Demo: Emitting ${event}`, data);
    }
  };

  const on = (event, callback) => {
    // Demo mode - no real socket events for now
    console.log(`Demo: Listening for ${event}`);
  };

  const off = (event, callback) => {
    // Demo mode - no real socket events for now
    console.log(`Demo: Stopped listening for ${event}`);
  };

  const value = {
    socket,
    isConnected,
    emit,
    on,
    off,
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};
